module.exports = __webpack_public_path__ + "static/media/hbrs.b58c674e.jpg";